import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://i.imgur.com/EHyR2nP.png",
  alt: "The cover of Stubborn Attachments"
}, null, -1)
const _hoisted_3 = { class: "description" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "$20.00", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  id: "checkout-button",
  type: "submit"
}, "Checkout", -1)

import { ref } from 'vue';

import { SessionUser } from '../../utils/SessionUser';
import { useRoute } from 'vue-router';
import { Session } from '../../../framework/frontend/Session';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  setup(__props) {

const isString = (value) :value is string => {
  return typeof value === 'string' || value instanceof String;
}

const type = ref("standard");
const url = `/checkout-session/${SessionUser.instance.userId}`;
const token = Session.getJwtToken()

const route = useRoute();
if(isString( route.query.type)){
  type.value = route.query.type;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(type.value), 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("form", {
      action: url,
      method: "POST"
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
        hidden: "",
        name: "type"
      }, null, 512), [
        [_vModelText, type.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(token) ? (token).value = $event : null)),
        hidden: "",
        name: "token"
      }, null, 512), [
        [_vModelText, _unref(token)]
      ]),
      _hoisted_5
    ])
  ]))
}
}

})